<template>
  
  <div class="app-modal-container">

    <app-auth-modal></app-auth-modal>

  </div>

</template>

<script>

import Events from '@/app/events.js'
import AuthModalComponent from '@/components/admin/app-modal/components/AuthModalComponent'


export default {
  name: 'app-modal-container',
  components: {
    "app-auth-modal":AuthModalComponent
  },
  data () {
    return {
      
    }
  },

  mounted(){

  },



}

</script>
